import { useMediaQuery } from "@vueuse/core";
import { computed, Ref } from "vue";
import { BREAKPOINT_SMALL } from "../constants";

interface DeviceCheckResult {
  isTouchDevice: Ref<boolean>;
  isSmallScreenSize: Ref<boolean>;
  isMobile: Ref<boolean>;
  canUseFullScreen: boolean;
}

let deviceCheckResult: DeviceCheckResult | null = null;

export const useDeviceCheck = (): DeviceCheckResult => {
  if (deviceCheckResult == null) {
    const isTouchDevice = useMediaQuery("(pointer: coarse)");
    const isSmallScreenSize = useMediaQuery(
      // eslint-disable-next-line max-len
      `(max-width: ${BREAKPOINT_SMALL}) and (orientation: portrait), (max-height: ${BREAKPOINT_SMALL}) and (orientation: landscape)`
    );
    const isMobile = computed(() => isSmallScreenSize.value && isTouchDevice.value);
    const canUseFullScreen = !!(
      document.documentElement.requestFullscreen ||
      document.documentElement.mozRequestFullScreen ||
      document.documentElement.webkitRequestFullscreen ||
      document.documentElement.msRequestFullscreen
    );

    deviceCheckResult = {
      isTouchDevice,
      isSmallScreenSize,
      isMobile,
      canUseFullScreen,
    };
  }

  return deviceCheckResult;
};
